import { makeStyles } from 'tss-react/mui';

export const useFormLayoutStyles = makeStyles()(theme => ({
  header: {
    alignItems: 'center',
    background: '#fff',
    boxShadow: 'inset 0 -1px 0 rgba(0, 0, 0, .12)',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    height: '62px',
    margin: 'auto',
    maxWidth: '1440px',
    minHeight: '62px',
    width: '100%',
    zIndex: 1000,
  },
  headerButton: {
    padding: 0
  },
  headerWrapper: {
    background: '#fff',
    boxShadow: 'inset 0 -1px 0 rgba(0, 0, 0, .12)',
    height: '62px',
  },
  logo: {
    display: 'flex',
    justifyContent: 'center',
    '& svg path': {
      fill: '#434C55'
    }
  },
  main: {
    flex: 1
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(8, 2, 10, 2),
    [theme.breakpoints.up('sm')]: {
      margin: '0 auto',
      paddingTop: theme.spacing(13),
      width: '588px'
    }
  },
}));

export const useFooterStyles = makeStyles()(theme => ({
  alignButtonLeft: {
    justifyContent: 'flex-start',
  },
  centerButton: {
    justifyContent: 'center',
  },
  footer: {
    alignItems: 'center',
    background: '#fff',
    bottom: 0,
    boxShadow: 'inset 0px 1px 0px rgba(0, 0, 0, 0.12)',
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    padding: theme.spacing(2),
    position: 'fixed',
    right: 0,
    zIndex: 1000,
    [theme.breakpoints.up('sm')]: {
      boxShadow: 'none',
      height: '74px',
      marginTop: theme.spacing(8),
      position: 'static'
    }
  },
  footerBase: {
    display: 'flex',
    gap: theme.spacing(2),
    width: '100%',
    '& button': {
      flex: 1,
    },
    [theme.breakpoints.up('sm')]: {
      gap: 'unset',
      '& button': {
        flex: 'unset',
        width: 'auto'
      }
    }
  },
  footerBorder: {
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  },
  noBorder: {
    [theme.breakpoints.down('md')]: {
      boxShadow: 'none'
    }
  },
  replacedFooter: {
    display: 'flex',
    gap: theme.spacing(2),
    height: '100%',
    width: '100%',
    '& button': {
      flex: 1,
      width: '100%'
    },
  },
  spaceBetween: {
    justifyContent: 'space-between',
  }
}));
